import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { sanitizeStyleTags } from "../../../../../../core/common-service/CommonService";
import RichChapterEditor from "./RichChapterEditor";
import "./SingleChapterView.css";

const VISIBLE_WORD_COUNT = 150;

const SingleChapterView = ({
  chapter,
  isPaid,
  onPayClick,
  onChangeTextArea,
}) => {
  const { t } = useTranslation();

  const content = chapter?.generated_content || "";

  // Split content into visible and blurred parts
  const { visibleContent, blurredContent, hasBlurredContent } = useMemo(() => {
    if (isPaid || !content) {
      return {
        visibleContent: content,
        blurredContent: "",
        hasBlurredContent: false,
      };
    }

    const words = content.split(/\s+/);
    if (words.length <= VISIBLE_WORD_COUNT) {
      return {
        visibleContent: content,
        blurredContent: "",
        hasBlurredContent: false,
      };
    }

    const visibleWords = words.slice(0, VISIBLE_WORD_COUNT);
    const blurredWords = words.slice(VISIBLE_WORD_COUNT);

    return {
      visibleContent: visibleWords.join(" "),
      blurredContent: blurredWords.join(" "),
      hasBlurredContent: true,
    };
  }, [content, isPaid]);

  // If paid, show editable textarea like normal chapters
  if (isPaid) {
    return (
      <div className="single-chapter-view">
        {/* <div className="single-chapter-header">
          <h3 className="single-chapter-title">{bookTitle || t("your_book")}</h3>
        </div> */}
        <div className="single-chapter-content-wrapper">
          <RichChapterEditor
            content={content}
            onChange={(newContent) =>
              onChangeTextArea({ target: { value: newContent } })
            }
            className="single-chapter-textarea"
          />
        </div>
      </div>
    );
  }

  // Not paid - show partial content with blur
  return (
    <div className="single-chapter-view">
      <div className="single-chapter-header">
        <div className="free-preview-badge">
          <i className="fa-solid fa-eye"></i>
          <span>{t("free_preview")}</span>
        </div>
      </div>

      <div className="single-chapter-content-wrapper">
        {/* Visible content */}
        <div className="single-chapter-visible-content">
          <p
            dangerouslySetInnerHTML={{
              __html: sanitizeStyleTags(visibleContent),
            }}
          />
        </div>

        {/* Blurred content with overlay */}
        {hasBlurredContent && (
          <div className="single-chapter-blurred-section" onClick={onPayClick}>
            {/* Gradient fade overlay */}
            <div className="single-chapter-fade-overlay"></div>

            {/* Blurred content */}
            <div className="single-chapter-blurred-content">
              <p
                dangerouslySetInnerHTML={{
                  __html: sanitizeStyleTags(blurredContent),
                }}
              />
            </div>

            {/* Unlock CTA overlay */}
            <div className="single-chapter-unlock-overlay">
              <div className="unlock-cta">
                <i className="fa-solid fa-lock unlock-icon"></i>
                <h4>{t("unlock_full_content")}</h4>
                <p>{t("click_to_unlock_description")}</p>
                <button className="btn btn-primary unlock-button">
                  <i className="fa-solid fa-unlock me-2"></i>
                  {t("unlock_now")}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SingleChapterView;
